(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips} <a href="/pages/build-your-box" class="bb-build-link">– Customise →</a>`;
  }

  const socialProof = '★★★★★ Absolutely unreal bars';

  const cravingImages = {
    'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-PDP.jpg?v=1775654171',
    'caramel2':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Caramel_Craving_box_2_bars_PDP.png?v=1776270709',
    'caramel3':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-3.png?v=1776271237',
    'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Peanut-PDP.jpg?v=1776242810',
    'pistachio':    null,
    'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
    'raspberry2':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_flat_lay_craving_PDP_image.png?v=1776083133',
    'raspberry3':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_Raspberry_3.png?v=1776243690',
    'raspberry4':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_smashed_craving_ad_ii.png?v=1776362170',
    'pretzel':      null,
    'smaltz':       null,
    'enrobingtrio': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Barney_goff_Remove_the_card_keep_everything_else_the_same_f3459f72-60c4-49ab-b3e6-db75b2ebea7c.png?v=1776429327',
    'pistachioupclose': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Pistachio_smashed_up_close.png?v=1776689430',
  };

  const cravingFlavours = {
    'caramel':      'Caramel',
      'caramel2':   'Caramel',
      'caramel3':  'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'raspberry2':   'Raspberry',
    'raspberry3':   'Raspberry',
    'raspberry4':   'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'enrobingtrio': 'Peanut Butter',
    'pistachioupclose': 'Pistachio',
  };

  Object.entries(cravingFlavours).forEach(([key, displayName]) => {
    const flavourList = buildFlavourList(displayName);
    const flavourChips = buildFlavourChips(displayName);
    const pdpImage = cravingImages[key];

    // Version A — box in cart (no cartImage)
    window.adConfigs[`craving-${key}`] = {
      subline1:  "Here we are",
      subline2:  flavourChips,
      cartSub:   flavourList,
      image:     pdpImage,
      cartImage: null,
      socialProof,
    };

    // Version B — PDP image in cart
    window.adConfigs[`craving-${key}-pdpcart`] = {
      subline1:  "Here we are",
      subline2:  flavourChips,
      cartSub:   flavourList,
      image:     pdpImage,
      cartImage: pdpImage,
      socialProof,
    };
  });

  // peanutbutter2 variant
  window.adConfigs['craving-peanutbutter2'] = {
    subline1:  "Here we are.",
    subline2:  buildFlavourChips('Peanut Butter'),
    cartSub:   buildFlavourList('Peanut Butter'),
    image:     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_ad_outside_caramel_stretch.png?v=1775820938',
    cartImage: null,
    socialProof,
  };

  // peanutbutter2 pdpcart variant
  window.adConfigs['craving-peanutbutter2-pdpcart'] = {
    subline1:  "Here we are.",
    subline2:  buildFlavourChips('Peanut Butter'),
    cartSub:   buildFlavourList('Peanut Butter'),
    image:     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_ad_outside_caramel_stretch.png?v=1775820938',
    cartImage: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_ad_outside_caramel_stretch.png?v=1775820938',
    socialProof,
  };

})();